import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'as-fancyloader',
  templateUrl: './fancyloader.component.html',
  styleUrls: ['./fancyloader.component.scss']
})
export class FancyloaderComponent implements OnInit {

  items = [];
  @Input() type;
  @Input() length;
  @Input() headers;

  constructor() { }


  ngOnInit() {

    for (let i =0 ; i< this.length; i++){
      this.items.push(1)
    }



  }

}
